// Copyright (c) Docugami, Inc. All rights reserved.

import { dgFontFamily } from "components/common/Fonts";
import { homeGray } from "components/shell/presentation/AppStyles";
import styled from "styled-components";

const CountTextRoot = styled.span`
    font-family: ${dgFontFamily};
    font-size: 11px;
    font-weight: 400;
    color: ${homeGray};
`

const CountTextBold = styled(CountTextRoot)`
    font-weight: 700;
`

interface CountTextProps {
    count: number
    itemName: string;
}

export const CountText = (props: CountTextProps): JSX.Element => {
    return (
        <CountTextRoot>
            <CountTextBold>{props.count}</CountTextBold>
            {` ${props.itemName.toLocaleLowerCase()}${props.count !== 1 ? 's' : ''}`}
        </CountTextRoot>
    );
}
